import { berachain, berachainBepolia, kaia, kairos } from '@lair-finance/wagmi/chains'
import { isDevelopment } from '@/shared/constants/env.ts'
import { getIconPath } from '@/shared/lib/utils/asset.ts'

export const Chains = {
  KAIA: kaia,
  KAIA_TESTNET: kairos,
  BERA: berachain,
  BERA_TESTNET: berachainBepolia,
} as const

export enum ChainId {
  KAIA = Chains.KAIA.id,
  KAIA_TESTNET = Chains.KAIA_TESTNET.id,
  BERA = Chains.BERA.id,
  BERA_TESTNET = Chains.BERA_TESTNET.id,
}

export const DEFAULT_CHAIN = isDevelopment ? Chains.KAIA_TESTNET : Chains.KAIA
export const ACTIVE_KAIA_CHAIN = isDevelopment ? Chains.KAIA_TESTNET : Chains.KAIA
export const ACTIVE_BERA_CHAIN = isDevelopment ? Chains.BERA_TESTNET : Chains.BERA

export const CHAIN_IMAGE_DIRECTORY = 'chain'

export const ChainImageFilenames: Record<ChainId, string> = {
  [ChainId.KAIA]: 'kaia.png',
  [ChainId.KAIA_TESTNET]: 'kaia.png',
  [ChainId.BERA]: 'bera.png',
  [ChainId.BERA_TESTNET]: 'bera.png',
} as const

export const ChainImages: Record<ChainId, string> = {
  [ChainId.KAIA]: getIconPath(ChainImageFilenames[ChainId.KAIA], CHAIN_IMAGE_DIRECTORY),
  [ChainId.KAIA_TESTNET]: getIconPath(ChainImageFilenames[ChainId.KAIA_TESTNET], CHAIN_IMAGE_DIRECTORY),
  [ChainId.BERA]: getIconPath(ChainImageFilenames[ChainId.BERA], CHAIN_IMAGE_DIRECTORY),
  [ChainId.BERA_TESTNET]: getIconPath(ChainImageFilenames[ChainId.BERA_TESTNET], CHAIN_IMAGE_DIRECTORY),
} as const

export const ChainNames: Record<ChainId, string> = {
  [ChainId.KAIA]: 'Kaia',
  [ChainId.KAIA_TESTNET]: 'Kairos',
  [ChainId.BERA]: 'Bera',
  [ChainId.BERA_TESTNET]: 'Bepolia',
}
